/* Hakhatu — vá nhỏ khi đặt design lên theme Pokens.
   Tách khỏi hakhatu.js (bê nguyên từ landing page) để lần sau tái sinh
   hakhatu.js từ design không nuốt mất các bản vá này. */
(function () {
  'use strict';

  /* Badge giỏ hàng: <xo-cart-size> của Pokens tự điền số, kể cả khi giỏ trống
     thì vẫn ghi "0" (theme gốc cũng vậy — xem .toolbar__cart-count). Design
     Hakhatu là chấm coral nổi, để "0" trong đó nhìn sai. Không dùng được CSS
     thuần vì không selector nào khớp theo nội dung chữ, và component không set
     attribute [xo-empty] như .xo-predictive-search__wishlist-count. */
  function syncCartBadge() {
    document.querySelectorAll('.hk-root .cart-badge').forEach(function (badge) {
      var n = (badge.textContent || '').trim();
      badge.hidden = (n === '' || n === '0');
    });
  }

  function watch() {
    syncCartBadge();
    var targets = document.querySelectorAll('.hk-root .cart-badge xo-cart-size');
    if (!targets.length) return;
    var mo = new MutationObserver(syncCartBadge);
    targets.forEach(function (t) {
      mo.observe(t, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  /* Sau khi thêm vào giỏ, Pokens phát sự kiện của riêng nó; bắt thêm vài mốc
     phổ biến để badge cập nhật ngay thay vì đợi tải lại trang. */
  ['cart:updated', 'xo:cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, syncCartBadge);
  });

  /* Swiper tính bề rộng slide một lần lúc khởi tạo và nhớ luôn `size` đó.
     Trên Shopify, lúc hakhatu.js chạy thì ảnh/webfont chưa xong nên trang chưa
     có thanh cuộn dọc -> container đo được 1266px, sau đó co còn 1240px mà
     swiper không biết. Hệ quả: slide rộng 240px thay vì 235px, đủ để card cuối
     bị hụt một góc.

     Lưu ý: swiper.update() KHÔNG tính lại breakpoint. Phải ép
     currentBreakpoint = null rồi setBreakpoint() thì mới đọc lại
     slidesPerView/spaceBetween của breakpoint hiện tại. */
  function refreshCarousels() {
    document.querySelectorAll('.hk-root [data-carousel]').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || sw.destroyed) return;
      try {
        sw.currentBreakpoint = null;
        sw.setBreakpoint();
        sw.update();
      } catch (e) { /* swiper chưa sẵn sàng thì bỏ qua, lần sau gọi lại */ }
    });
  }

  var raf;
  function scheduleRefresh() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(refreshCarousels);
  }

  window.addEventListener('load', scheduleRefresh);        // ảnh xong -> layout chốt
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleRefresh);
  // hakhatu.js khởi tạo swiper sau DOMContentLoaded; chạy thêm một nhịp cho chắc
  setTimeout(scheduleRefresh, 1200);

  /* Theo dõi bằng ResizeObserver chứ không nghe window.resize: bề rộng carousel
     còn đổi vì những lý do không kèm resize cửa sổ (thanh cuộn xuất hiện, ảnh
     tải xong đẩy layout, mở/đóng drawer, đổi zoom). Observer bắt hết. */
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(scheduleRefresh);
    var attach = function () {
      document.querySelectorAll('.hk-root [data-carousel]').forEach(function (el) { ro.observe(el); });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attach);
    else attach();
  } else {
    window.addEventListener('resize', scheduleRefresh);
  }

  /* Main menu sticks after the first scroll; the in-page About navigation stays
     in the document flow instead of covering content. */
  function initScrollStickyHeader() {
    document.querySelectorAll('.hk-root .site-header').forEach(function (header) {
      if (header.dataset.scrollStickyReady === 'true') return;
      header.dataset.scrollStickyReady = 'true';

      var spacer = document.createElement('div');
      spacer.className = 'site-header-spacer';
      spacer.setAttribute('aria-hidden', 'true');

      function update() {
        var shouldStick = window.scrollY > 0;
        if (shouldStick) {
          if (!spacer.parentNode) header.parentNode.insertBefore(spacer, header.nextSibling);
          spacer.style.height = header.offsetHeight + 'px';
          header.classList.add('is-scroll-sticky');
        } else {
          header.classList.remove('is-scroll-sticky');
          if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
        }
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initScrollStickyHeader);
  else initScrollStickyHeader();
})();

/* === BẢNG: bọc cuộn + gắn nhãn cột cho chế độ xếp chồng trên mobile === */
(function () {
  'use strict';

  // Chạy trên DOM chứ không sửa từng chỗ viết bảng: nội dung bảng đến từ nhiều
  // nguồn (body_html của trang, block liquid trong tab, section) và có thể do
  // người khác thêm sau. Làm ở đây thì bảng nào cũng được xử lý.
  var SCOPES = '.hk-page table, xo-tabs-pane table';

  function enhance(root) {
    (root || document).querySelectorAll(SCOPES).forEach(function (table) {
      if (table.parentNode && table.parentNode.classList.contains('hk-table-wrap')) return;

      var wrap = document.createElement('div');
      wrap.className = 'hk-table-wrap';
      table.parentNode.insertBefore(wrap, table);
      wrap.appendChild(table);

      var rows = table.querySelectorAll('tr');
      var headCells = table.querySelectorAll('thead th');
      var headerRow = null;

      // Nhiều bảng viết tay không có <thead>: hàng đầu toàn <th> vẫn là hàng
      // tiêu đề. Nhận cả hai kiểu, nếu không sẽ xếp chồng sai trên mobile.
      if (!headCells.length && rows.length) {
        var first = rows[0];
        var cells = first.children;
        var allTh = cells.length > 0;
        for (var c = 0; c < cells.length; c++) if (cells[c].tagName !== 'TH') allTh = false;
        if (allTh && cells.length >= 3) { headerRow = first; headCells = cells; }
      }

      if (headCells.length >= 3) {
        var labels = Array.prototype.map.call(headCells, function (th) {
          return (th.textContent || '').trim();
        });
        Array.prototype.forEach.call(rows, function (tr) {
          if (tr === headerRow) { tr.setAttribute('data-header-row', '1'); return; }
          if (tr.parentNode && tr.parentNode.tagName === 'THEAD') return;
          Array.prototype.forEach.call(tr.children, function (cell, i) {
            if (labels[i]) cell.setAttribute('data-label', labels[i]);
          });
        });
        wrap.setAttribute('data-stack', '1');
      } else if (!table.querySelectorAll('thead th').length && table.querySelectorAll('tbody th').length) {
        wrap.setAttribute('data-stack', '2');
      }
      // Còn lại: giữ nguyên, chỉ cuộn ngang.
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(); });
  else enhance();

  // Tab sản phẩm và modal quick-view chèn nội dung sau khi trang đã tải.
  var mo = new MutationObserver(function (list) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].addedNodes.length) { enhance(); return; }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();


/* ============================================================
   Vi tri mo cua drawer mobile.

   Drawer truoc day dat top co dinh (94px / 84px). Nhung header doi vi tri
   giua hai trang thai:
     - da cuon  -> .is-scroll-sticky, position: fixed, chiem 0-77
     - dau trang-> position: relative, nam duoi thanh thong bao, chiem 63-140
   Voi top co dinh 84px, o dau trang drawer mo DE LEN chinh nut hamburger,
   nen bam lan nua khong dong duoc menu ma trung vao nut accordion cua drawer.

   Day do day header that vao bien --hk-drawer-top, cap nhat khi cuon, khi doi
   kich thuoc, va khi drawer bat/tat.
   ============================================================ */
(function () {
  'use strict';
  function init() {
    var header = document.querySelector('.hk-root .site-header');
    var nav = document.getElementById('mobile-navigation');
    if (!header || !nav) return;
    if (nav.dataset.drawerOffsetReady === 'true') return;
    nav.dataset.drawerOffsetReady = 'true';

    function update() {
      var r = header.getBoundingClientRect();
      /* header co the da cuon khuat (bottom am) truoc khi kip thanh sticky:
         khi do neo drawer sat mep tren, khong de no bay ra ngoai man hinh. */
      var top = Math.round(r.bottom) + 8;
      if (!isFinite(top) || top < 8) top = 8;
      document.documentElement.style.setProperty('--hk-drawer-top', top + 'px');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    /* nut bam doi thuoc tinh hidden -> do lai ngay truoc khi drawer hien */
    new MutationObserver(update).observe(nav, { attributes: true, attributeFilter: ['hidden'] });
    /* header doi class sticky -> chieu cao va vi tri doi theo */
    new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['class'] });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

(function () {
  'use strict';
  function initHakhatuMobileMenuSteps() {
    var root = document.querySelector('[data-hk-mobile-root]');
    if (!root || root.dataset.hkMobileStepsReady === 'true') return;
    root.dataset.hkMobileStepsReady = 'true';

    var views = Array.prototype.slice.call(root.querySelectorAll('[data-hk-mobile-view]'));
    function showView(name) {
      views.forEach(function (view) {
        var active = view.getAttribute('data-hk-mobile-view') === name;
        view.hidden = !active;
        view.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      root.dataset.hkMobileView = name;
      var activeView = root.querySelector('[data-hk-mobile-view="' + name + '"]');
      if (activeView) activeView.scrollTop = 0;
    }

    root.addEventListener('click', function (event) {
      var next = event.target.closest('[data-hk-mobile-step]');
      var back = event.target.closest('[data-hk-mobile-back]');
      if (next) {
        event.preventDefault();
        showView(next.getAttribute('data-hk-mobile-step'));
      } else if (back) {
        event.preventDefault();
        showView(back.getAttribute('data-hk-mobile-back'));
      }
    });

    var mobileToggle = document.querySelector('[data-mobile-toggle]');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        window.setTimeout(function () {
          if (!root.hidden) showView('root');
        }, 0);
      });
    }
    new MutationObserver(function () {
      if (root.hidden) showView('root');
    }).observe(root, { attributes: true, attributeFilter: ['hidden'] });

    showView('root');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initHakhatuMobileMenuSteps);
  else initHakhatuMobileMenuSteps();
})();

/* == hk-hover-anh-the: bat dau == */
(function () {
  'use strict';
  /* Hover thẻ sản phẩm: tải ảnh "chưa có mặt" (data-src) ở lần rê chuột ĐẦU vào thẻ, tải xong mới gắn .is-ready để CSS
     mờ vào. Không tải trước: ảnh cảnh ~110 KB × 24 thẻ = 2,6 MB lúc mở trang. Chỉ máy có chuột. Markup: snippets/product-image.liquid. */
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    var card = t && t.closest ? t.closest('.xo-product-card') : null;
    if (!card) return;
    var im = card.querySelector('img.hk-hover-img[data-src]');
    if (!im) return;
    var u = im.getAttribute('data-src');
    im.removeAttribute('data-src');
    im.addEventListener('load', function () { im.classList.add('is-ready'); }, { once: true });
    im.src = u;
  }, { passive: true });
})();
/* == hk-hover-anh-the: het == */
